import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const {
  endpoints: {
    providers: { available },
  },
} = config

const getAvailable = (type, params) => axios.get(available.replace(':type', type), { headers: getHeaders(true), params })

export default { getAvailable }
